import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly activeRequestsSubject = new BehaviorSubject<number>(0);
  readonly activeRequests$: Observable<number> = this.activeRequestsSubject.asObservable();

  show(): void {
    this.activeRequestsSubject.next(this.activeRequestsSubject.value + 1);
  }

  hide(): void {
    this.activeRequestsSubject.next(Math.max(0, this.activeRequestsSubject.value - 1));
  }
}
